export default String.raw`
.newsletter {
    padding: 32px 32px;
    min-height: 332px;

    &__container {
        grid-template-rows: min-content auto;
        grid-template-areas: "h h"
                            "c f"
                            "c f";

        &-title {
            div {
                h3 {
                    @include h2-headline;
                }
    
                p {
                    display: none;
                }
            }
        }

        &-content {
            padding: 8px 0;

            &-icons {
                grid-template-columns: 100%;
            }
        }

        &-form {
            padding: 0;
            row-gap: 16px;

            &-info {
                display: block;
            }

            p {
                order: 1;

                &:first-child {
                    width: 100%;
                    order: 1;
                }
            }

            div {
                order: 1;

                &:first-child {
                    order: 1;
                    width: 100%;
                }
            }

            button {
                min-width: 100%;
                max-width: 100%;
            }
        }
    }
}
`